// eslint-disable-next-line import/no-extraneous-dependencies
import GaugeComponent from 'react-gauge-component';
import { BaseProps } from 'types';
import {
    RED_500, ORANGE_500, YELLOW_500, GREEN_600, GREY_200, GREY_500, GREY_100,
} from '../../../../../constants';
import { HEALTH_SCORE_MAX } from '../../constants';

const tooltipStyle = {
    fontSize: '12px',
    textShadow: 'unset',
    border: `1px solid ${GREY_100}`,
};

export interface HealthIndicatorLegendProps extends BaseProps {
    score?: number | null;
}

const HealthIndicatorLegend = ({ score, className }: HealthIndicatorLegendProps) => (
    <GaugeComponent
        className={className}
        value={score ?? 0}
        type="semicircle"
        minValue={0}
        maxValue={HEALTH_SCORE_MAX}
        arc={{
            width: 0.3,
            padding: 0.015,
            cornerRadius: 2,
            subArcs: [
                {
                    limit: 39,
                    color: RED_500,
                    showTick: true,
                    tooltip: {
                        text: 'Critical',
                        style: tooltipStyle,
                    },
                },
                {
                    limit: 59,
                    color: ORANGE_500,
                    showTick: true,
                    tooltip: {
                        text: 'At Risk',
                        style: tooltipStyle,
                    },
                },
                {
                    limit: 79,
                    color: YELLOW_500,
                    showTick: true,
                    tooltip: {
                        text: 'Stable',
                        style: tooltipStyle,
                    },
                },
                {
                    limit: 100,
                    color: GREEN_600,
                    showTick: true,
                    tooltip: {
                        text: 'Healthy',
                        style: tooltipStyle,
                    },
                },
            ],
        }}
        pointer={{
            type: 'needle',
            color: GREY_200,
            baseColor: GREY_200,
            length: 0.7,
            width: 8,
            maxFps: 30,

        }}
        labels={{
            valueLabel: {
                hide: true,
            },
            tickLabels: {
                type: 'outer',
                defaultTickValueConfig: {
                    formatTextValue: (e) => e,
                    style: { fontSize: '12px', fill: GREY_500 },
                },
                defaultTickLineConfig: { color: GREY_500, length: 4, width: 1 },
            },
        }}
    />
);

export default HealthIndicatorLegend;
